import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../core/services/auth.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'angular-2-local-storage';

declare let Razorpay: any;

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
  public currency = 'INR';
  @Input() data = {} as {theme_class?: string, show_border?: boolean, font_class?: string, referer?: string};
  public theme_id = 1;
  constructor(
    private activeModal: NgbActiveModal,
    private authService: AuthService,
    private localStorageService: LocalStorageService
  ) {
    this.theme_id = this.localStorageService.get('theme_id') || 1;
  }

  ngOnInit() {
  }
  startPayment(currency, amount) {
    const payload = {
      key: 'rzp_live_A8AQMQDf03O30d',
      payment_capture: true,
      currency: 'USD',
      amount: '295', // 2000 paise = INR 20
      name: 'MyResumeFormat',
      description: 'Subscription',
      image: 'https://myresumeformat.com/assets/images/logo.png',
      handler: this.paymentCallBack,
      prefill: {
        name: this.authService.session.profile.first_name,
        email: this.authService.session.profile.email,
        contact: this.authService.session.profile.phone
      },
      notes: {
        address: this.authService.session.profile.city
      },
      theme: {
        color: '#006df7'
      },
      'modal': {
        'ondismiss': function() {
          // location.reload();
        }
      }
    }
    payload.currency = currency;
    payload.amount = amount;
    const rzp = new Razorpay(payload);
    rzp.open();
  }
  paymentCallBack = (data) => {
    this.authService.processPayment(data.razorpay_payment_id).subscribe(res => {
      location.reload();
    });
  }
  myPay() {
    this.authService.processPayment('pay_EVAPl8Q99Di7C0').subscribe(res => {
      location.reload();
    });
  }
  dismiss() {
    this.activeModal.dismiss({reload: false});
  }

}
